export default function Footer() {
    return (
        <footer className="flex flex-wrap items-center justify-between relative bg-primary px-4 md:px-10 min-h-[60px]">
            <div className="flex flex-wrap items-center justify-center py-4 flex-auto w-full">
                <p className="text-sm sm:text-base text-white text-center">
                    Contact Dylan Coggins at <a className="hover:underline" href="mailto:dylan.coggins@switchdigital.net.au">dylan.coggins@switchdigital.net.au</a>, <strong>0458 158 786</strong> for any assistance.
                </p>
            </div>
        </footer>
    );
}
